enum ModifierKeys {
    Alt = "Alt",
    Control = "Control",
    // windows or Command 
    Meta = "Meta",
    Shift = "Shift"
}

export default ModifierKeys;